import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
// import { useNavigate } from "react-router-dom";
import useApiUrls from "../../useApiUrls";
import Pagination from "../components/Pagination";

const DevicePackageList = () => {
    //   const navigate = useNavigate();
    const { getUrlByOperation } = useApiUrls();
    const [data, setData] = useState([]);
    const [dataLimit, setDataLimit] = useState(100);
    const [count, setCount] = useState(0); // This is page number
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    // Filter states
    const [types, setTypes] = useState([]);
    const [formData, setFormData] = useState({
        serialno: "",
        type: "",
    });

    const token = getCookie("token");
    const userid = getCookie("userid");

    // Fetch unique types for filter
    const fetchTypes = async () => {
        try {
            const response = await axios.get(
                "https://api.dqr-display-tms.eventum.co.in/api/DeviceInfoHistory/GetDistinct/type",
                {
                    headers: {
                        accept: "text/plain",
                        "X-Authorization": token,
                        UserId: userid,
                    },
                }
            );
            if (response.data && response.data.isresponse && Array.isArray(response.data.data)) {
                setTypes(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching types:", error);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                "https://api.dqr-display-tms.eventum.co.in/api/DeviceInfoHistory/Search",
                {
                    pagesize: dataLimit,
                    currentpageno: count,
                    withoutpagination: false,
                    pagedirection: "", // "first" was in curl example but typically empty or next/prev
                    serialno: formData.serialno || "",
                    type: formData.type || "",
                },
                {
                    headers: {
                        "Content-Type": "application/json-patch+json",
                        accept: "text/plain",
                        "X-Authorization": token,
                        UserId: userid,
                    },
                }
            );

            if (response.data && Array.isArray(response.data.data)) {
                setData(response.data.data);
                const rows = response.data.data;
                setHasMore(rows.length === dataLimit);
                const approximateTotal = (count * dataLimit) + rows.length + (rows.length === dataLimit ? dataLimit : 0);
                setTotalItems(approximateTotal);
            } else {
                setData([]);
                setHasMore(false);
                setTotalItems(0);
            }
        } catch (error) {
            console.error("Error fetching history data:", error);
            setData([]);
            setHasMore(false);
            setTotalItems(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTypes();
    }, []);

    useEffect(() => {
        fetchData();
    }, [count, dataLimit]); // Fetch when page or limit changes. Search is manual? Or implicit?
    // User usually expects search button to trigger search, but pagination triggers fetch.

    const handleSearch = () => {
        setCount(0); // Reset to first page
        fetchData();
    };

    const handleReset = () => {
        setFormData({
            serialno: "",
            type: "",
        });
        setCount(0);
        // fetchData(); // Optional: auto fetch on reset
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handlePageChange = (page) => {
        setCount(page - 1);
    };

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setDataLimit(newItemsPerPage);
        setCount(0);
    };

    const computedTotalPages = hasMore ? count + 2 : count + 1;

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h1 className="mb-0">Device Info History</h1>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">

                            {/* Search Form */}
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Serial No</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="serialno"
                                                    value={formData.serialno}
                                                    onChange={handleChange}
                                                    placeholder="Enter Serial No"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Type</label>
                                                <select
                                                    className="form-control"
                                                    name="type"
                                                    value={formData.type}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Type</option>
                                                    {types.map((t, index) => (
                                                        <option key={index} value={t.value}>
                                                            {t.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4 d-flex align-items-end">
                                            <div className="form-group mb-0">
                                                <button
                                                    className="btn btn-primary mr-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search
                                                </button>
                                                <button
                                                    className="btn btn-warning"
                                                    onClick={handleReset}
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Table Card */}
                            <div className="card">
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover table-striped text-nowrap">
                                         <thead className="" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                                            <tr>
                                                <th>ID</th>
                                                <th>Created Date</th>
                                                <th>Pos Name</th>
                                                <th>Merchant ID</th>
                                                <th>Serial No</th>
                                                <th>Type</th>
                                                <th>Data</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center p-4">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.id}</td>
                                                        <td>{item.createddate}</td>
                                                        <td>{item.posname}</td>
                                                        <td>{item.merchantid}</td>
                                                        <td>{item.serialno}</td>
                                                        <td>
                                                            <span className="badge badge-info">{item.type}</span>
                                                        </td>
                                                        <td style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis" }} title={item.data}>
                                                            {item.data}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No data found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <Pagination
                                    currentPage={count + 1}
                                    totalPages={computedTotalPages}
                                    onPageChange={handlePageChange}
                                    itemsPerPage={dataLimit}
                                    onItemsPerPageChange={handleItemsPerPageChange}
                                    totalItems={totalItems}
                                    showPageNumbers={false}
                                    showItemsPerPageSelector={true}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default DevicePackageList;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
